import { createSlice } from '@reduxjs/toolkit';

export const scheduleEditorSlice = createSlice({
	name: 'scheduleEditor',
	initialState: {
		scheduleData: {
			lastDateSelected: false,
		},
		template: {
			name: '',
			templateWorkouts: [],
		},
	},
	reducers: {
		setScheduleData: (state, action) => {
			state.scheduleData = action.payload.scheduleData;
		},
		setTemplate: (state, action) => {
			state.template = {
				...state.template,
				...action.payload,
			};
		},
		clearScheduleData: (state) => {
			state.scheduleData = {
				lastDateSelected: false,
			};
		},
		clearTemplate: (state) => {
			state.template = {
				name: '',
				templateWorkouts: [],
			};
		},
	},
});

export const {
	setScheduleData,
	setTemplate,
	clearScheduleData,
	clearTemplate,
} = scheduleEditorSlice.actions;

export default scheduleEditorSlice.reducer;
